module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-date-fill-06e57253.svg";